(function () {
  const CLONE_KEYWORD = 'clone'; // Nom exact de ta variante
  const FEE_HANDLE = 'supplement-livraison-clone'; // Handle du produit supplément

  let feeVariantIdCache = null;
  let syncing = false;

  async function fetchFeeVariantId() {
    if (feeVariantIdCache) return feeVariantIdCache;
    const res = await fetch(`/products/${FEE_HANDLE}.js`);
    if (!res.ok) {
      console.warn('[CLONE FEE] Produit supplément introuvable:', FEE_HANDLE);
      return null;
    }
    const prod = await res.json();
    const v = prod.variants && prod.variants[0];
    feeVariantIdCache = v ? v.id : null;
    return feeVariantIdCache;
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return await r.json();
  }

  function countCloneQty(cart) {
    let qty = 0;
    (cart.items || []).forEach(item => {
      const opts = (item.options_with_values || []).map(o => (o.value || '').toLowerCase());
      if (opts.some(v => v === CLONE_KEYWORD)) qty += item.quantity;
    });
    return qty;
  }

  function findFeeLine(cart) {
    return (cart.items || []).find(i =>
      (i.handle && i.handle === FEE_HANDLE) ||
      (i.product_handle && i.product_handle === FEE_HANDLE) ||
      (i.product_title && i.product_title.toLowerCase().includes('supplément') && i.product_title.toLowerCase().includes('clone'))
    );
  }

  async function updateCartQuantities(updates) {
    return await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates })
    }).then(r => r.json());
  }

  async function addFee(variantId, quantity) {
    if (!variantId || quantity <= 0) return;
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    }).then(r => r.json());
  }

  async function syncFee() {
    if (syncing) return;
    syncing = true;
    try {
      const [variantId, cart] = await Promise.all([fetchFeeVariantId(), getCart()]);
      if (!variantId) return;

      const requiredQty = countCloneQty(cart);
      const feeLine = findFeeLine(cart);
      const currentFeeQty = feeLine ? feeLine.quantity : 0;

      if (requiredQty === currentFeeQty) return;

      if (requiredQty === 0 && feeLine) {
        await updateCartQuantities({ [feeLine.key]: 0 });
        document.dispatchEvent(new CustomEvent('cart:refresh-requested'));
        return;
      }

      if (!feeLine && requiredQty > 0) {
        await addFee(variantId, requiredQty);
        document.dispatchEvent(new CustomEvent('cart:refresh-requested'));
        return;
      }

      if (feeLine && requiredQty > 0) {
        await updateCartQuantities({ [feeLine.key]: requiredQty });
        document.dispatchEvent(new CustomEvent('cart:refresh-requested'));
        return;
      }
    } catch (e) {
      console.warn('[CLONE FEE] Erreur sync:', e);
    } finally {
      syncing = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncFee();

    document.body.addEventListener('submit', (e) => {
      const form = e.target;
      if (form && form.matches('form[action*="/cart/add"]')) {
        setTimeout(syncFee, 700);
        setTimeout(syncFee, 1500);
      }
    });

    document.body.addEventListener('change', (e) => {
      const el = e.target;
      if (el && (el.name === 'updates[]' || el.name === 'quantity' || el.closest('cart-items') || el.closest('cart-drawer'))) {
        setTimeout(syncFee, 500);
        setTimeout(syncFee, 1200);
      }
    });

    ['cart:updated', 'cart:refresh', 'cart:changed', 'product:added', 'cart:drawer:open']
      .forEach(evt => document.addEventListener(evt, () => setTimeout(syncFee, 400)));
  });
})();
// Verrouiller la ligne "supplément" dans le panier (page + drawer)
document.addEventListener('DOMContentLoaded', () => {
  function lockFeeUI() {
    const sel = 'a[href*="/products/supplement-livraison-clone"]';
    document.querySelectorAll(sel).forEach(a => {
      const item = a.closest('.cart-item, cart-drawer-item, .drawer__cart-item, li, tr');
      if (!item) return;
      item.querySelectorAll('quantity-input, .quantity, .quantity__button, [name="updates[]"], button[name="remove"], .cart-remove, .remove, [data-cart-remove], .cart-item__remove').forEach(el => {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('tabindex', '-1');
      });
    });
  }

  // au chargement + après chaque refresh du panier
  lockFeeUI();
  ['cart:updated','cart:refresh','cart:changed','cart:drawer:open'].forEach(evt =>
    document.addEventListener(evt, () => setTimeout(lockFeeUI, 200))
  );
});

